/** @file       main.jsx
 *  @author     Alex Huctwith <alex@kingsds.network>
 *
 *  @date       April 2022
 *
 *              React app index file
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';

// Make sure css files imported in child components have higher precendence due to declaration order
import './index.css'; 
import './App.css';
import '@/styles/page.css';
import '@/styles/form.css';
import '@/styles/utils.css';

import App from './App';
import { LoginOperations } from '@/features/auth';
import '@/lib/i18n';
import { AppProvider } from '@/providers/app';

async function main()
{
  if (sessionStorage.getItem('auth-directive') === 'logout')
  {
    sessionStorage.removeItem('auth-directive');
    await LoginOperations.handleLogout();
    return;
  }

  await LoginOperations.handleLogin();
  const appRoot = document.getElementById('root');
  const root = createRoot(appRoot);

  Modal.setAppElement(appRoot);

  root.render(
    <React.StrictMode>
      <AppProvider>
        <App />
      </AppProvider>
    </React.StrictMode>,
  );
}
main();
